
<div *ngIf="showOverlay" class="at-the-top fullComponent overlay-min overflow-hidden">
  <div class="fullComponent m-Auto overflow-hidden">
    <div id="overlay" class="fullComponent flex-display justify-content-center screen-overlay" [@slideInOut]="overlayState" (click)="overlayClicked()">
      <div *ngIf="overlayOption != 'Terms And Conditions' && overlayOption != 'About GARS' && overlayOption != 'print preview'" class="overlay-content"
           [style.width]="contentWidth"
           [@slideInOut]="overlayState"
           (@slideInOut.start)="startAnimation()"
           (@slideInOut.done)="animationDone()"
           (click)="overlayContentClicked()"
           (appClickOutside)="outsideClick($event)">
        <div class="close-left-overlay" aria-label="CloseFullScreen" role="form" tabindex="0" *ngIf="childComponent">
          <button role="button" mat-button class="close-right-overlay-btn" (click)="viewPreviousScreen()"
                  (keyup.enter)="viewPreviousScreen()" tabindex="0">
            <img src="../../../assets/icons/arrow-left-blue.svg" class="back-arrow-icon" alt="Arrow Left">
            <span>Back</span>
          </button>
        </div>
        <div class="close-right-overlay" aria-label="close overlay" role="form" tabindex="0" (click)="closeOverlay()" (keyup.enter)="closeOverlay()">
          <button role="button" mat-button class="close-right-overlay-btn">
            Close<mat-icon class="close-nav-icon">close</mat-icon>
          </button>
        </div>

        <div [ngSwitch]="overlayOption" class="rightOverlay_scroll">
          <app-bookmark role="navigation" aria-label="Add Bookmark" *ngSwitchCase="'Add Bookmark'" (myEvent)="closeOverlayBookmark()"></app-bookmark>
          <app-provide-feedback role="navigation" aria-label="Provide Feedback" *ngSwitchCase="'Provide Feedback'" (myEvent)="closeOverlayAnnotation()"></app-provide-feedback>
          <app-general-feedback role="navigation" aria-label="General Feedback" *ngSwitchCase="'General Feedback'" (myEvent)="closeOverlayAnnotation()"></app-general-feedback>
          <app-xblr-elements role="navigation" aria-label="See XBLR elements" *ngSwitchCase="'See XBLR elements'"></app-xblr-elements>
          <app-your-annotation role="navigation" aria-label="Your Annotation" *ngSwitchCase="'Your Annotations'" (myEvent)="closeOverlayAnnotation()"></app-your-annotation>
          <app-annotations role="navigation" aria-label="Add Annotation" *ngSwitchCase="'Add Annotation'" (myEvent)="closeOverlayAnnotation()"></app-annotations>
          <app-contact-support role="navigation" aria-label="Contact Support" *ngSwitchCase="'Contact Support'" (myEvent)="closeRightOverlay()"></app-contact-support>
          <app-help-source-tracing role="navigation" aria-label="Source Tracing Rool Help" *ngSwitchCase="'sourcetracingtoolhelp'" (myEvent)="closeRightOverlay()"></app-help-source-tracing>
          <app-acronyms role="navigation" aria-label="Acronyms" *ngSwitchCase="'Acronyms'" (myEvent)="closeRightOverlay()"></app-acronyms>
          <app-inline-glossary role="navigation" aria-label="inline-glossary" [TermId]="glossaryTermId" *ngSwitchCase="'inline-glossary'" (myEvent)="closeRightOverlay()"></app-inline-glossary>
          <app-archive role="navigation" aria-label="Archive" *ngSwitchCase="'Archive'" (myEvent)="closeRightOverlay()"></app-archive>
          <app-what-links-here role="navigation" aria-label="What Links Here" *ngSwitchCase="'What Links Here'" (myEvent)="closeRightOverlay()"></app-what-links-here>
          <app-logout-users-popup role="navigation" aria-label="Logout Users" *ngSwitchCase="'Logout Users'" (myEvent)="closeRightOverlay()"></app-logout-users-popup>
          <app-glossary-term-usage role="navigation" aria-label="glossary-term-usage" *ngSwitchCase="'glossary-term-usage'" [GlossaryTermData]="glossaryTermData" (myEvent)="closeRightOverlay()"></app-glossary-term-usage>
          <app-glossary-term-topic role="navigation" aria-label="glossary-term-topic" *ngSwitchCase="'glossary-term-topic'" [GlossaryTermData]="glossaryTermData" (myEvent)="closeRightOverlay()"></app-glossary-term-topic>
          <app-related-content role="navigation" aria-label="Related content" *ngSwitchCase="'Related content'" (myEvent)="closeRightOverlay()"></app-related-content>
          <app-pdfhelp role="navigation" aria-label="pdfviewer" *ngSwitchCase="'pdfviewer'" (myEvent)="closeRightOverlay()"></app-pdfhelp>
          <app-add-user role="navigation" aria-label="Add/Update User" *ngSwitchCase="'addUpdateUser'" [IsRightPanel]="true" (myEvent)="closeRightOverlay()"></app-add-user>

        </div>

      </div>
      <div *ngIf="overlayOption == 'Terms And Conditions'" class="flex-display justify-content-center">
        <div class="modal-overlay">
          <div class="height-5rem bgc-fasb-blue flex-display justify-content-space-between align-items-center">
            <img alt="logo" [src]="logo" class="icon-fasb-logo mb-1 ">
            <button *ngIf="closeModalBool || closeModalAction" mat-button (click)="closeOverlay()" class="close-modal">
              Close<mat-icon class="close-nav-icon">close</mat-icon>
            </button>
          </div>
          <app-terms-and-condition-content (myEvent)="closeOverlay()"></app-terms-and-condition-content>
        </div>
      </div>
      <div *ngIf="overlayOption == 'About GARS'" class="flex-display justify-content-center">
        <div class="aboutGARS modal-overlay">
          <div class="height-5rem bgc-fasb-blue flex-display justify-content-space-between align-items-center">
            <img alt="logo" [src]="logo" class="icon-fasb-logo mb-1 ">
            <button *ngIf="closeModalBool || closeModalAction" mat-button (click)="closeOverlay()" class="close-modal">
              Close<mat-icon class="close-nav-icon">close</mat-icon>
            </button>
          </div>
          <app-about-us></app-about-us>
        </div>
      </div>
      <div *ngIf="overlayOption == 'print preview'" class="flex-display justify-content-center mainprintoverlaycontainer" style="width:70%">
        <div class="modal-overlay-print-preview">
          <div class="height-6rem bgc-fasb-blue flex-display justify-content-space-between align-items-center">
            <img alt="logo" [src]="logo" class="icon-fasb-logo mb-1 ">
            <button mat-button (click)="closeOverlayPrintPreview()" class="close-modal">
              <mat-icon class="close-nav-icon">close</mat-icon>
            </button>
          </div>
          <div id="print-preview-content-main" class="tc-article-print-container container">
            <div class="page-header ">
              <div class="flex-display justify-content-space-between padding-left-right"  style="border-bottom:2px solid #d8dce2; padding-bottom:0.5rem;">
                <p>{{dateNow}}</p>
                <p class="">gars.gasb.org</p>
                <p>Content Version : {{archiveVersion}}</p>
              </div>
            </div>
            <div class="page-footer" style="margin-top: 0.5rem; padding-top: 0.5rem;">
              <p style=" margin-top:1rem !important;"></p>
              <p class="copyrightNoticeFooter padding-left-right" style="border-top: 2px solid #d8dce2 !important; padding-top:0.5rem;">
                Copyright © {{year}} by Financial Accounting Foundation. All rights reserved. Certain portions may include material copyrighted by American Institute of Certified Public Accountants or Government Finance Officers Association. Content copyrighted by Financial Accounting Foundation, or any third parties who have not provided specific permission, may not be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of Financial Accounting Foundation or such applicable third party.
              </p>
            </div>
            <table class="width-100 " aria-describedby="table_right_overlay">
              <thead>
                <tr style="margin-bottom:1rem;">
                  <th id="thPageHeaderSpace">
                    <div class="page-header-space"></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div id="printscroll" [ngClass]="[contentPaddingValue]">
                      <div id="scrollToTop" style="letter-spacing: 0.2px;">
                        <div id="printPara">
                          <div class="printBox" id="printHeader">
                            <div class="generalHeader" id="pageHeadingprint"></div>
                          </div>
                          <article id="printPreviewArticle" class="article-font"></article>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="row">
                  <td>
                    <div class="page-footer-space"></div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div>
            <div id="topLoad" (click)="gotoSection()" class="back-To-Top" style="display:none" (keyup.enter)="gotoSection()" tabindex="0">
              <span style="display: inline-block; margin: 15px 0px 0 0;">Back to Top</span>
              <div class="back-To-Top-img" style="text-align: center;">
                <img style="margin-top: 12px;" src="../../../assets/icons/ArrowUp-white.svg" alt="Back to top" />
              </div>
            </div>
            <div class="tc-acction-btns" style="background-color: #CBD2DD">
              <button mat-button class="btn-secondary-action-close btn-secondary-print-p" (click)="closeOverlayPrintPreview()" (keyup.enter)="closeOverlayPrintPreview()" tabindex="0">Cancel</button>
              <button mat-button class="btn-primary-action-add btn-secondary-print-p" printSectionId="print-preview-content-main" ngxPrint [useExistingCss]="true" styleSheetFile="assets/ngxPrintCss/customPrint.css">Print</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
